var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9497 7.50915V8.11041V19.3177C23.9497 20.0426 23.2116 20.6303 22.3012 20.6303H5.53499C4.62468 20.6303 3.88672 20.0427 3.88672 19.3179V8.23004V7.50903",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5902 6.89057H2.82601C1.81751 6.89057 1 6.31946 1 5.61495L2.66552 2.27568C3.19102 1.25915 3.48303 1 4.49153 1H14.0819L12.4164 5.61484C12.0606 6.44374 11.5987 6.89057 10.5902 6.89057Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4098 6.89057H25.174C26.1825 6.89057 27 6.31946 27 5.6149L25.3345 2.27568C24.6572 1.09542 24.517 1 23.5085 1H13.7528L15.3583 5.6149C15.7056 6.46198 16.4013 6.89057 17.4098 6.89057Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9181 1.09753V21",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.fe1b568daa5be0cde8cb504a82373cbd.svg";
export { ForwardRef as ReactComponent };